import { testimonials } from "../../../mocks/testimonials";

export default function TestimonialsSection() {
  return (
    <section className="bg-[#EEF2F9] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <span className="text-[#C9A84C] text-xs font-semibold uppercase tracking-widest block mb-3">
            Investor Testimonials
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold text-[#071A2E]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            What Our Investors Say
          </h2>
          <p className="text-slate-500 text-sm mt-3 max-w-md mx-auto">
            Feedback from certified high net worth and sophisticated investors currently participating in the Thorpe Dellow Social Housing Structured Product.
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
          {testimonials.map((t) => (
            <article
              key={t.id}
              className="break-inside-avoid bg-white rounded-2xl p-6 hover:shadow-sm transition-shadow"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="font-semibold text-[#071A2E] text-sm">{t.name}</p>
                  <p className="text-xs text-slate-400">{t.role}</p>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-[#C9A84C] text-xs leading-none" />
                  </div>
                ))}
              </div>
              <p className="text-slate-600 text-sm leading-relaxed">
                &ldquo;{t.review}&rdquo;
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
